/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Signals_Detected_YetInputs */

const en_no_signals_detected_yet = /** @type {(inputs: No_Signals_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No signals detected yet`)
};

const es_no_signals_detected_yet = /** @type {(inputs: No_Signals_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no se detectaron señales`)
};

const fr_no_signals_detected_yet = /** @type {(inputs: No_Signals_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun signal détecté pour l'instant`)
};

const de_no_signals_detected_yet = /** @type {(inputs: No_Signals_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Signale erkannt`)
};

const ja_no_signals_detected_yet = /** @type {(inputs: No_Signals_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだシグナルは検出されていません`)
};

const zh_no_signals_detected_yet = /** @type {(inputs: No_Signals_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未检测到信号`)
};

const ar_no_signals_detected_yet = /** @type {(inputs: No_Signals_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم اكتشاف إشارات بعد`)
};

const id_no_signals_detected_yet = /** @type {(inputs: No_Signals_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada sinyal terdeteksi`)
};

const it_no_signals_detected_yet = /** @type {(inputs: No_Signals_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun segnale rilevato finora`)
};

const ru_no_signals_detected_yet = /** @type {(inputs: No_Signals_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока сигналов не обнаружено`)
};

const pt_no_signals_detected_yet = /** @type {(inputs: No_Signals_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum sinal detectado ainda`)
};

const ko_no_signals_detected_yet = /** @type {(inputs: No_Signals_Detected_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 감지된 시그널이 없습니다`)
};

/**
* | output |
* | --- |
* | "No signals detected yet" |
*
* @param {No_Signals_Detected_YetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_signals_detected_yet = /** @type {((inputs?: No_Signals_Detected_YetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Signals_Detected_YetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_signals_detected_yet(inputs)
	if (locale === "es") return es_no_signals_detected_yet(inputs)
	if (locale === "fr") return fr_no_signals_detected_yet(inputs)
	if (locale === "de") return de_no_signals_detected_yet(inputs)
	if (locale === "ja") return ja_no_signals_detected_yet(inputs)
	if (locale === "zh") return zh_no_signals_detected_yet(inputs)
	if (locale === "ar") return ar_no_signals_detected_yet(inputs)
	if (locale === "id") return id_no_signals_detected_yet(inputs)
	if (locale === "it") return it_no_signals_detected_yet(inputs)
	if (locale === "ru") return ru_no_signals_detected_yet(inputs)
	if (locale === "pt") return pt_no_signals_detected_yet(inputs)
	return ko_no_signals_detected_yet(inputs)
});